import { LOGIN, LOGIN_ERROR, LOGIN_LOADING, LOGIN_RET, LOGOUT, LOGOUT_CLR, LOGOUT_RET, REGISTER, REGISTER_ERROR, REGISTER_LOADING, REGISTER_RET, WHOAMI, WHOAMI_ERROR, WHOAMI_LOADING, WHOAMI_RET } from "../Constants"

export const login = (data) => {
    return {
        type: LOGIN,
        data
    }
}

export const loginRet = (data) => {
    return {
        type: LOGIN_RET,
        data
    }
}

export const loginLoading = (data) => {
    return {
        type: LOGIN_LOADING,
        data
    }
}

export const loginError = () => {
    return {
        type: LOGIN_ERROR
    }
}

export const whoami = (data) => {
    return {
        type: WHOAMI,
        data
    }
}

export const whomaiRet = (data) => {
    return {
        type: WHOAMI_RET,
        data
    }
}

export const whoamiLoading = (data) => {
    return {
        type: WHOAMI_LOADING,
        data
    }
}

export const whoamiError = () => {
    return {
        type: WHOAMI_ERROR
    }
}

export const logout = (data) => {
    return {
        type:LOGOUT,
        data
    }
}

export const logout_ret = (data) => {
    return {
        type:LOGOUT_RET,
        data
    }
}
export const logout_clr = (data) => {
    return {
        type:LOGOUT_CLR,
        data
    }
}

export const register = (data) => {
    return {
        type: REGISTER,
        data
    }
}

export const registerRet = (data) => {
    return {
        type: REGISTER_RET,
        data
    }
}

export const registerLoading = (data) => {
    return {
        type: REGISTER_LOADING,
        data
    }
}

export const registerError = () => {
    return {
        type: REGISTER_ERROR
    }
}